import { LOCATION_CHANGE } from 'react-router-redux'

const DEFAULT_STATE = {
  prevPathname: '',
}

let prevPathname = ''

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      const newState = {
        ...state,
        prevPathname,
      }
      prevPathname = action.payload.pathname
      return newState

    default:
      return state
  }
}

export default record
